import http from "@/utils/http";

export default {
    /**
     * 查询试卷列表
     * @param query
     * @returns {*}
     */
    findExamPaperList(query) {
        console.log(query);
        return http.get("/exam/paper/page", query);
    },
    /**
     * 获取试卷的基本信息 - 编辑可用
     * @param params
     */
    getUpdateBaseInfoOne(params) {
        return http.get("/exam/paper/update/info", params);
    },
    /**
     * 获取试卷的基本信息
     * @param params
     */
    getBaseInfoOne(params) {
        return http.get("/exam/paper/base/info/one", params);
    },

    /**
     * 试卷详情（预览）
     * @param params
     * @returns {*}
     */
    getOne(params) {
        return http.post("/exam/paper/option/info", params);
    },
    add(params) {
        return http.post("/examPapers/", params);
    },
    /**
     * 删除试卷
     * @param params
     * @returns {*}
     */
    del(params) {
        return http.delete("/exam/paper/del", params);
    },
    update(id, params) {
        return http.put(`/examPapers/${id}`, params);
    },
    /**
     * 修改试卷状态
     * @param params
     * @returns
     */
    updateState(params) {
        return http.put("/exam/paper/state/mod", params);
    },
    /**
     * 新增手动添加试卷
     * @param params
     */
    addManuaPaper(params) {
        return http.post("/exam/paper/manual/add", params);
    },
    /**
     * 新增自动添加试卷
     * @param params
     */
    addAutoPaper(params) {
        return http.post("/exam/paper/auto/add", params);
    },
    /**
     * 修改手动添加试卷
     * @param params
     */
    updateManualPaper(params) {
        return http.put("/exam/paper/manual/update", params);
    },
    /**
     * 修改自动添加试卷
     * @param params
     */
    updateAutoPaper(params) {
        return http.put("/exam/paper/auto/update", params);
    },
    /**
     * 获取自动生成的试卷集合
     * @param params
     * @returns {*}
     */
    getPaperTitileList(params) {
        return http.get("/exam/paper/auto/title/list", params);
    },

    /*= ==============================默认试卷==============================
     * 生成所有默认试卷
     * @param params
     * @returns {*}
     */
    saveAllDefaultGenerate(params) {
        return http.post("/exam/default/paper/generate/all/list", params);
    },
    /**
     * 生成单个默认试卷
     */
    saveOneDefaultGenerate(params) {
        return http.post("/exam/default/paper/generate/one", params);
    },
    /*
     * 清除单个默认试卷
     * */
    clearDefaultPnePaper(params) {
        return http.put("/exam/default/paper/clear/one", params);
    },
    /**
     * 清除所有默认试卷
     */
    cleanAllPaper(params) {
        return http.put("/exam/default/paper/clear/all/list", params);
    },
    /**
     * 刷新岗位
     *
     */
    refreshDuty() {
        return http.put("/exam/default/paper/duty/refresh");
    },
    /**
     *  刷新岗位默认试卷
     *
     */
    refreshDutyDefualtPaper(params) {
        return http.put("/exam/default/paper/refresh", params);
    },

    /**
     * 获取默认试卷的基础信息
     * @param params
     * @returns {*}
     */
    getDefautPaperBase(params) {
        return http.get("/exam/default/paper/base/info", params);
    },

    /**
     * 获取默认试卷列表
     * @param query
     * @returns {*}
     */
    findDefaultPaperList(params) {
        return http.get("/exam/default/paper/list", params);
    },
};
/**
 * 校验是否能添加试题
 * @param query
 * @returns {*}
 */
export const checkExamPaperValidExercises = (params) => {
    return http.post("/exam/paper/valid/exercises", params);
};

/**
 * 获取考试预览列表
 * @param params
 * @returns {*}
 */
export const getExamPaperPreview = (params) => {
    return http.post("/exam/paper/preview", params);
};
